import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

export const CustomButton = styled(Button)({
  backgroundColor: "#00205b",
  width: "100%",
  height: "60px",
  color: "white",
  borderRadius: "30px",
  "&:hover": {
    backgroundColor: "#6edcfa",
    boxShadow: "none",
  },
  "&:disabled": {
    backgroundColor: "grey",
    color: "white",
  },
});
